import apiClient from 'hub-http/clients/apiClient';
import { getFullUrl } from 'hubspot-url-utils';
import { getHublet } from '../store/app/selectors';
import { getPortalId } from '../store/auth/selectors';
export const fetchGates = state => {
  const url = `${getFullUrl('app-api', {
    hubletOverride: getHublet(state)
  })}/hubs/v1/hubs/${getPortalId(state)}/ungatings`;
  return apiClient.get(url);
};